function CardVisaForm() {
  return (
    <div className="payment-form fade">
      <h3>Pagamento com Cartão Visa</h3>

      <input placeholder="Número do Cartão" />
      <div className="row">
        <input placeholder="MM/AA" />
        <input placeholder="CVV" />
      </div>

      <button onClick={(e)=>{alert("Sem Disponibilidade Escolhe via Express ou Transferencia, Obrigado")}} className="pay-btn">Pagar com Visa</button>
    </div>
  );
}

export default CardVisaForm;
